module.exports = __webpack_public_path__ + "2a63dd9605e122f9bd8abbcfd9476836.png";